// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions
// .FaqHost. Note the exact (legacy) strings: Default omits the group dot, and
// EditCategoryFeatures maps to ".EditFaqCategoryFeatures".
export const FaqHostPermissions = {
  default: 'HostPagesFaqAdmin',
  createCategory: 'HostPages.CreateFaqCategory',
  editCategory: 'HostPages.EditFaqCategory',
  deleteCategory: 'HostPages.DeleteFaqCategory',
  createFaq: 'HostPages.CreateFaq',
  editFaq: 'HostPages.EditFaq',
  deleteFaq: 'HostPages.DeleteFaq',
  editCategoryFeatures: 'HostPages.EditFaqCategoryFeatures',
} as const;
